import Component from './Component';
import Choices from "choices.js";

export default class SelectComponent extends Component {

    get SELECTORS() {
        return {
            main: '.customselect__button',
            item: '.customselect__list-item',
            search: '.customselect__list-search',
            option: '[role="option"]'
        }
    }

    get CLASSES() {
        return {
            hide: 'hide'
        }
    }

    get ARIA() {
        return {
            roles: {
                combobox: 'combobox',
                listbox: 'listbox',
                option: 'option'
            },
            attrs: {
                role: 'role',
                haspopup: 'aria-haspopup',
                expanded: 'aria-expanded',
                controls: 'aria-controls',
                labelledby: 'aria-labelledby',
                autocomplete: 'aria-autocomplete',
                readonly: 'aria-readonly',
                label: 'aria-label',
                activedescendant: 'aria-activedescendant'
            }
        };
    }

    get DATA() {
        return {
            selectedValue : 'selectValue'
        }
    }

    constructor() {
        super();
        this.typeAheadBuffer = '';
        this.typeAheadTimeout = null;
    }

    selectElement(element, valueToSelect) {
        element[0].focus();
        element[0].value = valueToSelect;
        element[0].blur();
        element[0].dispatchEvent(new Event('change'));
    }

    displyUl(element) {
        let selectDropdown, elementParentSpan;

        if (element.tagName == 'DIV') {
            selectDropdown = element.parentNode.getElementsByTagName('ul');

            if(element.firstChild.tagName == 'INPUT'){
                if(!selectDropdown[0].classList.contains('active')) {
                    selectDropdown[0].classList.add("active");
                    element.classList.add('active');
                    element.firstChild.focus();
                }
            } else {
                selectDropdown[0].classList.toggle("active");
                element.classList.toggle('active');
            }

        } else if (element.tagName == 'LI' && element.classList.contains('select')) {
            var selectId = element.parentNode.parentNode.getElementsByTagName('select');
            this.selectElement(selectId, element.getAttribute('data-value'));
            elementParentSpan = element.parentNode.parentNode.getElementsByTagName('span');
            element.parentNode.classList.toggle("active");
            element.parentNode.parentNode.getElementsByTagName('div')[0].classList.toggle('active');
            elementParentSpan[0].textContent = element.textContent;
            elementParentSpan[0].parentNode.setAttribute('data-value', element.getAttribute('data-value'));
        }
    }

    createSelect() {
        const selectElements = document.querySelectorAll(
            'select:not([data-computed="computed"]):not(.combobox):not(.legacy)'
        );

        selectElements.forEach(selectElement => {

            const validOptions = selectElement.querySelectorAll('option:not([disabled])');
            if (validOptions.length === 0) {
                return;
            }

            const choices = new Choices(selectElement, {
                searchEnabled: false,
                shouldSort: false,
                itemSelectText: '',
            });

            selectElement.choicesInstance = choices;

            const initial= selectElement.getAttribute(this.DATA.selectedValue);
            if (initial) {
                if (typeof choices.setChoiceByValue === 'function') {
                    choices.setChoiceByValue(initial);
                }
            } else {
                const nonDisabledOptions = selectElement.querySelectorAll('option:not([disabled]):not([value="null"])');
                if (nonDisabledOptions.length === 1 && selectElement.value === 'null') {
                    // Wait for Choices.js to be fully initialized
                    setTimeout(() => {
                        choices.setChoiceByValue(nonDisabledOptions[0].value);
                    }, 100);
                }
            }

            if (choices.initialisedOK) {
                selectElement.setAttribute('data-computed', 'computed');

                const outer = choices.containerOuter.element;
                const inner = choices.containerInner.element;

                const selectId    = inner.querySelector('select').id;
                const listBoxId   = selectId + '-listbox';
                const { roles, attrs } = this.ARIA;

                outer.setAttribute(attrs.role, roles.combobox);
                outer.setAttribute(attrs.haspopup, roles.listbox);
                outer.setAttribute(attrs.expanded, 'false');
                outer.setAttribute(attrs.controls, listBoxId);
                outer.setAttribute(attrs.labelledby, selectId + '-label');
                outer.setAttribute('tabindex', '0');
                outer.setAttribute(attrs.autocomplete, 'none');
                outer.setAttribute(attrs.readonly, 'true');
                outer.removeAttribute(attrs.label);

                const dropdownWrapper = outer.querySelector('.choices__list--dropdown');
                const realListBox     = dropdownWrapper.querySelector('[role="listbox"]');

                realListBox.setAttribute(attrs.role, roles.listbox);
                realListBox.id = listBoxId;
                realListBox.setAttribute('tabindex', '-1');

                outer.addEventListener('keydown', this.onComboboxKeydown.bind(this, realListBox, outer));

            }
        });
        this.createLegacySelect();
    }

    createLegacySelect() {
        var select = document.querySelectorAll('select.legacy:not([data-computed="computed"])'),
            liElement,
            ulElement;

        for (var select_i = 0, len = select.length; select_i < len; select_i++) {
            if(select[select_i].length > 0) {
                try {
                    select[select_i].classList.add('select-hide');
                    let el = select[select_i],
                        wrapper = document.createElement('div'),
                        i = select_i;

                    if(el.getAttribute('data-computed') === 'rendering' && el.parentNode.classList.contains('customselect')) {
                        let oldCustom = el.parentNode;
                        oldCustom.insertAdjacentElement('afterend', el);
                        oldCustom.remove();
                    }

                    el.parentNode.insertBefore(wrapper, el);
                    wrapper.appendChild(el);

                    document.addEventListener('click', function (e) {
                        //IE11
                        if(wrapper.hasChildNodes()) {
                            let clickInside = wrapper.contains(e.target);
                            if (!clickInside) {
                                let menu = wrapper.getElementsByClassName('customselect__list');
                                let button = wrapper.getElementsByClassName('customselect__button');
                                menu[0].classList.remove('active');
                                button[0].classList.remove('active');
                            }
                        }
                    });

                    let color = el.getAttribute('data-color'),
                        size = el.getAttribute('data-size');

                    let buttonElement = document.createElement("div"),
                        spanElement = document.createElement("span"),
                        iElement = document.createElement("i");
                    ulElement = document.createElement("ul");

                    wrapper.className = 'customselect customselect--' + i;
                    buttonElement.className = 'customselect__button';
                    buttonElement.setAttribute('data-value', '');
                    iElement.className = 'arrow arrow__down';
                    spanElement.className = 'customselect__text';
                    ulElement.className = 'customselect__list';
                    ulElement.id = 'customselect__list-' + i;

                    if(el.disabled) buttonElement.setAttribute('disabled', true);
                    if(color) wrapper.classList.add('customselect--' + color);
                    if(size) wrapper.classList.add('customselect--' + size);

                    wrapper.appendChild(buttonElement);

                    if(select[select_i].getAttribute('data-search') === 'true') {
                        let inputEl = document.createElement('input');
                        inputEl.type = 'text';
                        inputEl.placeholder=select[select_i].getAttribute('data-searchplaceholder');
                        inputEl.className = 'customselect__list-search';
                        buttonElement.appendChild(inputEl);
                    }

                    buttonElement.appendChild(spanElement);
                    buttonElement.appendChild(iElement);
                    wrapper.appendChild(ulElement);

                    switch (select[select_i].getAttribute('data-type')) {
                        case 'multiple':
                            for (const option of select[select_i].options) {
                                var newCheckbox = document.createElement('input'),
                                    newLabel = document.createElement('label');

                                newCheckbox.type = 'checkbox';
                                if(option.getAttribute('data-checked') === 'true') newCheckbox.checked = true;

                                newCheckbox.id = select[select_i].getAttribute('id') + '-checkbox-' + option.value;
                                newCheckbox.value =  option.value;
                                newLabel.htmlFor = newCheckbox.id;
                                newLabel.appendChild(document.createTextNode(option.text));

                                liElement = document.createElement("li");
                                liElement.appendChild(newCheckbox);
                                liElement.appendChild(newLabel);
                                liElement.className = 'customselect__list-item multiple ' + option.getAttribute('data-color');
                                // if(option.value) liElement.setAttribute('data-value', option.value);
                                if(!option.dataset.empty) ulElement.appendChild(liElement); //Select validation
                            }
                            break;
                        case 'link':
                            for (const option of select[select_i].options) {
                                liElement = document.createElement("a");
                                liElement.href = option.getAttribute('data-href');
                                liElement.className = 'customselect__list-item link ' + option.getAttribute('data-color');
                                if(option.value) liElement.setAttribute('data-value', option.value);
                                liElement.appendChild(document.createTextNode(option.text));
                                if(!option.dataset.empty) ulElement.appendChild(liElement); //Select validation
                            }
                            break;
                        default:
                            for (const option of select[select_i].options) {
                                liElement = document.createElement("li");
                                liElement.className = 'customselect__list-item select ' + option.getAttribute('data-color');
                                if(option.value) liElement.setAttribute('data-value', option.value);
                                liElement.appendChild(document.createTextNode(option.text));
                                if(!option.dataset.empty) ulElement.appendChild(liElement); //Select validation
                            }
                            break;
                    }

                    //  Setting default option or placeholder
                    var dropdownText = select[select_i].parentNode.getElementsByTagName('span')[0],
                        placeholder = select[select_i].getAttribute('placeholder'),
                        selectValue = select[select_i].getAttribute('selectValue');

                    if (placeholder) {
                        dropdownText.textContent = placeholder;
                    } else if (select[select_i].selectedIndex !== -1) {
                        dropdownText.textContent = select[select_i].options[select[select_i].selectedIndex].text;
                    } else {
                        dropdownText.textContent = select[select_i].options[0].text;
                    }

                    if (selectValue) {
                        select[select_i].value = selectValue;
                    }

                    select[select_i].setAttribute('data-computed', 'computed');
                }
                catch(err) {
                    console.warn(err);
                    select[select_i].classList.remove('select-hide');
                }
            }
        }
    }

    onComboboxKeydown(listBox, combobox, event) {
        const key = event.key;

        if (!/^[a-z0-9]$/i.test(key)) return;

        event.preventDefault();

        clearTimeout(this.typeAheadTimeout);
        this.typeAheadBuffer += key.toLowerCase();

        this.typeAheadTimeout = setTimeout(() => {
            this.typeAheadBuffer = '';
        }, 500);

        const options = Array.from(listBox.querySelectorAll(this.SELECTORS.option));

        const match = options.find(opt =>
            opt.textContent.trim().toLowerCase()
                .startsWith(this.typeAheadBuffer)
        );

        if (!match) return;

        const prev = listBox.querySelector('[aria-selected="true"]');
        if (prev) {
            prev.removeAttribute('aria-selected');
            prev.classList.remove('is-highlighted');
        }

        combobox.setAttribute(
            this.ARIA.attrs.activedescendant,
            match.id
        );

        match.setAttribute('aria-selected', 'true');
        match.classList.toggle('is-highlighted');
        match.scrollIntoView({ block: 'nearest' });
    }

    bindEvents() {

        this.events.on('keyup, touchend', this.SELECTORS.search, (e) => {
            this.filterFunction(e.target);
        });

        this.events.on('click', this.SELECTORS.main, (e) => {
            const element = e.target.matches(this.SELECTORS.main) ? e.target : e.target.closest(this.SELECTORS.main);
            this.displyUl(element);
        });

        this.events.on('click', this.SELECTORS.item, (e) => {
            this.displyUl(e.target);
        });
    }

    filterFunction(element) {
        const items = element.parentNode.parentNode.querySelectorAll(this.SELECTORS.item);
        items.forEach(item => {
            item.textContent.toUpperCase().indexOf(element.value.toUpperCase()) > -1 ?
                item.classList.remove(this.CLASSES.hide) : item.classList.add(this.CLASSES.hide);
        })
    }

    render() {
        this.createSelect();
        this.bindEvents();
        this.log('render Select');
    }
}